<dx-data-grid
    id="bdsReportGrid"
    bds-grid
    [dataSource]="gridSource"
    height="80vh"
    minHeight="200px"
    (onContentReady)="onContentReady($event)"
>
    <dxo-grouping [autoExpandAll]="true" [allowCollapsing]="false"></dxo-grouping>
    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxi-column
        dataField="fleet_id"
        caption="Fleet ID"
        [groupIndex]="0"
        [showWhenGrouped]="true"
    ></dxi-column>
    <dxi-column dataField="business_group" caption="Business Group"></dxi-column>
    <dxi-column dataField="at_consignee" caption="AT CONSIGNEE" dataType="number"></dxi-column>
    <dxi-column
        dataField="at_origin_empty"
        caption="AT ORIGIN EMPTY"
        dataType="number"
    ></dxi-column>
    <dxi-column
        dataField="at_origin_loaded"
        caption="AT ORIGIN LOADED"
        dataType="number"
    ></dxi-column>
    <dxi-column dataField="at_shop" caption="AT SHOP" dataType="number"></dxi-column>
    <dxi-column dataField="no_bills" caption="NO BILLS" dataType="number"></dxi-column>
    <dxi-column dataField="no_trips" caption="NO TRIPS" dataType="number"></dxi-column>
    <dxi-column dataField="to_consignee" caption="TO CONSIGNEE" dataType="number"></dxi-column>
    <dxi-column dataField="to_origin" caption="TO ORIGIN" dataType="number"></dxi-column>
    <dxi-column dataField="to_shop" caption="TO SHOP" dataType="number"></dxi-column>
    <dxi-column dataField="GRAND_TOTAL" caption="Grand total" dataType="number"></dxi-column>

    <dxo-summary>
        <dxi-group-item
            column="at_consignee"
            summaryType="sum"
            displayFormat="{0}"
            [showInGroupFooter]="true"
        ></dxi-group-item>
        <dxi-group-item
            column="at_origin_empty"
            summaryType="sum"
            displayFormat="{0}"
            [showInGroupFooter]="true"
        ></dxi-group-item>
        <dxi-group-item
            column="at_origin_loaded"
            summaryType="sum"
            displayFormat="{0}"
            [showInGroupFooter]="true"
        ></dxi-group-item>
        <dxi-group-item
            column="at_shop"
            summaryType="sum"
            displayFormat="{0}"
            [showInGroupFooter]="true"
        ></dxi-group-item>
        <dxi-group-item
            column="no_bills"
            summaryType="sum"
            displayFormat="{0}"
            [showInGroupFooter]="true"
        ></dxi-group-item>
        <dxi-group-item
            column="no_trips"
            summaryType="sum"
            displayFormat="{0}"
            [showInGroupFooter]="true"
        ></dxi-group-item>
        <dxi-group-item
            column="to_consignee"
            summaryType="sum"
            displayFormat="{0}"
            [showInGroupFooter]="true"
        ></dxi-group-item>
        <dxi-group-item
            column="to_origin"
            summaryType="sum"
            displayFormat="{0}"
            [showInGroupFooter]="true"
        ></dxi-group-item>
        <dxi-group-item
            column="to_shop"
            summaryType="sum"
            displayFormat="{0}"
            [showInGroupFooter]="true"
        ></dxi-group-item>
        <dxi-group-item
            column="GRAND_TOTAL"
            summaryType="sum"
            displayFormat="{0}"
            [showInGroupFooter]="true"
        ></dxi-group-item>
    </dxo-summary>
</dx-data-grid>
